import { NgFor, NgIf } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatError, MatHint, MatLabel } from '@angular/material/form-field';
import { DynamicFormOption } from '@ng-dynamic-forms/core';
import isNil from 'lodash/isNil';
import { WINDOW } from 'ngx-window-token';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { ChipChoiceMultipleModel } from './chip-choice-multiple.model';

// NOTE:
// The base class CustomDynamicFormControlComponent already includes all inputs and outputs needed, as well
// as additional convenience methods onDisabledChange() and onValueChange, for when model.disabled and model.value change,
// respectively.

@Component({
  selector:      'gsm-chip-choice-multiple',
  templateUrl:   'chip-choice-multiple.component.html',
  styleUrls:     ['chip-choice-multiple.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone:    true,
  imports:       [
    NgIf,
    MatLabel,
    MatChipListbox,
    NgFor,
    MatChipOption,
    MatHint,
    MatError
  ]
})
export class ChipChoiceMultipleComponent extends CustomDynamicFormControlComponent<ChipChoiceMultipleModel<any>> implements OnInit {

  private window = inject<Window>(WINDOW);

  private _isModelChanging = false;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected onModelChange() {
    this._isModelChanging = true;
    if (this.model.multiple && !this.model.value) {
      this.model.value = [];
    }
    // Wait for form to be intialized.
    this.window.setTimeout(() => {
      this._isModelChanging = false;
      this._emitChange();
    }, 0);
  }

  // Toggle option selection on/off.
  onChipSelectionChange(option: DynamicFormOption<any>, selected: boolean) {
    if (this._isModelChanging || this.model.disabled) {
      return;
    }

    if (this.model.multiple) {
      this.model.value = selected
        ? [
          ...(this.model.value || []),
          option.value
        ]
        : this.model.value?.filter(val => !this.model.compareWithFn(val, option.value));
    } else if (selected) {
      this.model.value = option.value;
    } else if (this.model.compareWithFn(this.model.value, option.value)) {
      this.model.value = null;
    }
    this._emitChange();
  }

  isOptionSelected(option: DynamicFormOption<any>) {
    return this.model.multiple
      ? this.model.value?.some(val => this.model.compareWithFn(option.value, val))
      : this.model.compareWithFn(this.model.value, option.value);
  }

  private _emitChange() {
    this._setErrors();
    this.change.emit(this.model.value);
  }

  private _setErrors() {
    const errors: ValidationErrors =
      this.model.required && (isNil(this.model.value) || (this.model.multiple && !this.model.value?.length)) ? {required: true} : null;
    this.group.get(this.model.id)
      .setErrors(errors);
  }
}
